const initialState = {}

const refresh = (state = initialState, action) => {
  switch (action.type) {
    case 'REFRESH_COUNTER':
      return {
        [action.name]: (state[action.name] || 0) + 1
      }
    default:
      return state
  }
}

export default refresh
